import React from 'react'
import PropTypes from 'prop-types'

import {
  Box, Image, ListItem, Text,
} from '@domain-group/suit-theme'

const LogoListItem = (props) => {
  const {
    callbacks: { uploadLogo },
    logo,
    size,
    title,
  } = props

  const { thumb, file_name } = logo || {}

  return (
    <ListItem
      boxProps={{
        borderBottom: '1px solid',
        fontSize: 'small',
        lineHeight: 1.3,
        justifyContent: 'space-between',
        padding: 'large',
        alignItems: 'center',
      }}
      onClick={() => uploadLogo()}
      showAngleIcon
    >
      {thumb && (
        <Image
          backgroundSize="contain"
          borderRadius={5}
          boxProps={{ border: '1px solid', borderColor: 'lineColor', marginRight: 'large' }}
          height={80}
          url={thumb}
          width={80}
        />
      )}

      <Box flexDirection="column">
        <Box>
          <Text width="fit-content">
            {title}
          </Text>

          <Text color="bodyFontLightColor" marginLeft="small" width="fit-content">
            {size}
          </Text>
        </Box>
        <Text
          color="bodyFontLightColor"
          fontSize="xsmall"
          maxWidth="80%"
          variant="ellipsis"
        >
          {file_name || 'Not Uploaded'}
        </Text>
      </Box>
    </ListItem>
  )
}

LogoListItem.propTypes = {
  callbacks: PropTypes.shape({
    uploadLogo: PropTypes.func.isRequired,
  }).isRequired,
  logo: PropTypes.object,
  size: PropTypes.string,
  title: PropTypes.string.isRequired,
}

export default LogoListItem
